// extracted by mini-css-extract-plugin
export default {"listProperty":"productProperty_listProperty__WzBda"};